export default __webpack_public_path__ + "static/media/connect.abda2ad1.svg";